 <template>
  <div>
    <div v-if="form" class="tags_container">
      <p><b>Tags</b></p>
      <div>
        <input class="outlined full_width" placeholder="..." v-model="form.data.user.fields.tags.value" @input="emit($event.target.value)">
      </div>
      <a
        @click="addTag(tag)"
        :class="{ 'is-outlined': !selected_tags.includes(tag) }"
        class="button is-info"
        :key="'tag_' + tag"
        v-for="tag in tagsNames"
        >{{ tag }}</a
      >
      <a
        v-if="internal_submit_button"
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-danger"
        >Submit</a
      >
    </div>
    <div v-if="!internal_submit_button" class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
// imports
import { mapMutations, mapGetters, mapActions } from 'vuex'

// constants
import { STORE_NAMESPACE, FETCH_ALL } from '@/store/modules/tag_list/types'

export default {
  name: 'tags-form',
  props: {
    payload: {
      type: Object,
      default: () => {}
    },
    internal_submit_button: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      is_loading: false,
      form: undefined,
      selected_tags: []
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters(STORE_NAMESPACE, ['tagsNames']),
    getTagsValue () {
      if (this.form == undefined) {
        return ''
      }
      return this.form.data.user.fields.tags.value
    }
  },
  watch: {
    getTagsValue (new_value) {
      this.emit(new_value)
    }
  },
  methods: {
    ...mapActions(STORE_NAMESPACE, [FETCH_ALL]),
    init () {
      this.$network_utils.getUser(this.payload.data.id).then(response => {
        this.setForm(response)
        this.selected_tags = response.tags == undefined ? [] : response.tags.split(', ')
      })
      this[FETCH_ALL]()
    },
    emit (value) {
      this.$emit('input', value)
    },
    addTag (tag) {
      this.selected_tags = this.form.data.user.fields.tags.value.length > 0 ? this.form.data.user.fields.tags.value.split(', ') : []
      if (this.selected_tags.includes(tag)) {
        this.removeTag(tag)
        return
      }
      this.selected_tags.push(tag)
      this.form.data.user.fields.tags.value = this.selected_tags.join(', ')
    },
    removeTag (tag) {
      for (let i = 0; i < this.selected_tags.length; i++) {
        if (this.selected_tags[i] == tag) {
          this.selected_tags.splice(i, 1)
        }
      }
      this.form.data.user.fields.tags.value = this.selected_tags.join(', ')
    },
    setForm (form_data) {
      this.form = new this.$form({
        user: {
          fields: {
            tags: {
              value: form_data.tags || '',
              has_error: false,
              validations: []
            },
            id: {
              value: form_data.id,
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: 'put',
            url: '/users/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'success' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
<style scoped>
  .tags_container a {
    margin-top: 10px;
    margin-right: 10px;
  }
</style>
